export enum LOCATIONS_FILTERS {
  CONTEXT = "context[organization]",
  LOCATION_ID = "filter[location_id]",
  ORGANIZATION_ID = "filter[organization_id]",
}
